<div class="card panel-flat-color secondary-panel flex-panel">
    <div class="panel-flat-header ws-flex-container-horizontal">
        <h3 class="ws-flex-auto ws-truncate">
            @if (userSetup) {
                <span>Additional</span>
            } {{ userInstanceService.getSelectedInstance().name }} Permissions
        </h3>
        <div class="ws-flex-none header-button-container">
            @if (!editMode && canEdit) {
                <button
                    helpTooltip
                    helpContentId="app.edit"
                    type="button"
                    class="ace-btn btn-text has-icon btn-primary"
                    [disabled]="!canEnterEditMode"
                    (click)="edit()">
                    <i class="fa fa-pencil fa-align"></i>
                </button>
            }
            @if (editMode && canEdit) {
                <button helpTooltip
                        helpContentId="app.save"
                        type="button"
                        class="ace-btn btn-text has-icon btn-primary"
                        (click)="save()"
                        [disabled]="!gridIsDirty"
                >
                    <i class="fa fa-save fa-align"></i>
                </button>
            }
            @if (editMode && canEdit) {
                <button helpTooltip
                        helpContentId="app.cancel"
                        type="button"
                        class="ace-btn btn-text has-icon btn-primary"
                        (click)="cancel()">
                    <i class="fa fa-times fa-align"></i>
                </button>
            }
            <ag-grid-filter-toggle [gridApi]="gridApi"></ag-grid-filter-toggle>
            @if (!isExpanded) {
                <button type="button" class="ace-btn btn-text has-icon btn-secondary" (click)="expandCollapse(true)">
                    <i class="fa fa-arrows-alt" helpTooltip helpContentId="expand"></i>
                </button>
            }
            @if (isExpanded) {
                <button type="button" class="ace-btn btn-text has-icon btn-secondary" (click)="expandCollapse(false)">
                    <i class="fa fa-compress" helpTooltip helpContentId="collapse"></i>
                </button>
            }
        </div>
    </div>
    <div class="panel-flat-body ws-flex-container-vertical">
        <ws-ag-grid-angular [gridOptions]="gridOptions"
                            (gridReady)="onAgGridReady($event)">
        </ws-ag-grid-angular>
    </div>
</div>
